<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col text-center">
        <div>
          <img src="/assets/images/page404.png" class="w-50" alt="">
        </div>
      </div>
    </div>
    <div class="row errorPage">
      <div class="col">
        <p>الصفحة غير موجودة!</p>
        <span>عذراً، الصفحة التي تبحث عنها غير متاحة أو قد تم حذفها، نرجو العودة </span><br>
        <span>إلى الصفحة الرئيسية.</span>
      </div>
    </div>
    <div class="row justify-content-center pt-3">
      <div class="col-11 col-md-5 text-center">
        <router-link to="/">
          <div class="btn-black">العودة إلى الصفحة الرئيسية</div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'Page404',
}
</script>
<style scoped>
  .height {
    height: 100vh;
  }
</style>